// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

export enum ProjectSettingAction {
    Create,
    Update,
    Other,
}
